export default cilindrata =>
  (Math.round(Math.round(cilindrata / 10) / 10) / 10).toFixed(1)
